// import { ui } from '@/api';
// import get from 'lodash.get';
// import services from '@/services/index';
import {useDBStore} from '@/stores/DBStore.store';

export default function dbServiceFactory(services) {
  let thisService = {
    init,
    openAsync,
    getAsync,
    addAsync,
    updateAsync,
    deleteAsync,
  };

  let dbStore;
  return thisService;

  ////////////////////
  function init() {
    dbStore = useDBStore();
  }

  function openAsync(dbName, storeName) {
    return new Promise((resolve, reject) => {
      const openRequest = window.indexedDB.open(dbName);
      openRequest.onerror = () => reject(openRequest.error);
      openRequest.onsuccess = () => {
        const db = openRequest.result;
        dbStore.setDB(dbName, db);
        resolve(db);
      };
      openRequest.onupgradeneeded = () => openRequest.result.createObjectStore(storeName);
    });
  }

  function getAsync(dbName, storeName, dbKey) {
    const db = dbStore.getDB(dbName);
    if (!db) {
      return Promise.reject('DB not initialized.  Call openDBAsych(dbName, storeName)');
    }

    return new Promise((resolve, reject) => {
      const transaction = db.transaction(storeName, 'readonly');
      const store = transaction.objectStore(storeName);
      const request = store.get(dbKey);
      request.onerror = () => { reject('oops') };
      request.onsuccess = e => { resolve(e.target.result)};
    });
  }

  function addAsync(dbName, storeName, key, value) {
    return new Promise((resolve, reject) => {
      const db = dbStore.getDB(dbName);
      const transaction = db.transaction([storeName], 'readwrite');
      transaction.onerror = event => {
        console.log('Transaction error', event)
        reject('oops');
      };

      const store = transaction.objectStore(storeName);
      const request = store.add(value, key);
      request.onerror = event => {
        console.log('Add error', event);
        reject('oops');
      };
      request.onsuccess = event => {
        console.log('Add success', event);
        resolve();
      };
    });
  }

  function updateAsync(dbName, storeName, key, value) {
    return new Promise((resolve, reject) => {
      const db = dbStore.getDB(dbName);
      const transaction = db.transaction([storeName], 'readwrite');
      transaction.onerror = event => {
        console.log('Transaction error', event)
        reject('oops');
      };

      const store = transaction.objectStore(storeName);
      const request = store.get(key);
      request.onerror = event => {
        console.log('Get error', event);
        reject('oops');
      };
      request.onsuccess = event => {
        const requestUpdate = store.put(value, key);
        requestUpdate.onerror = event => {
          console.log('Update error', event);
          reject('oops');
        }
        requestUpdate.onsuccess = event => {
          console.log('Update success', event);
          resolve();
        }
      };
    });
  }

  function deleteAsync(dbName, storeName, key) {
    return new Promise((resolve, reject) => {
      const db = dbStore.getDB(dbName);
      const transaction = db.transaction([storeName], 'readwrite');
      transaction.onerror = event => {
        console.log('Transaction error', event)
        reject('oops');
      };

      const store = transaction.objectStore(storeName);
      const request = store.delete(key);
      request.onerror = event => {
        console.log('Delete error', event);
        reject('oops');
      };
      request.onsuccess = event => {
        console.log('Delete success', event);
        resolve();
      };
    });
  }
}
